import { render, staticRenderFns } from "./RelatoriosAtividadesPorCliente.vue?vue&type=template&id=431f0e94"
import script from "./RelatoriosAtividadesPorCliente.vue?vue&type=script&lang=js"
export * from "./RelatoriosAtividadesPorCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports